import { IconTypes } from "@/components/icons/types";

export const DEFAULT_HIGHLIGHTS_TITLE =
  "Backed by academic excellence and industry recognition";

export const DEFAULT_HIGHLIGHTS_ITEMS = [
  {
    iconName: "certificate" as IconTypes,
    title: "School-certified",
    subtitle: "Earn a verified certificate from",
    showPartnerName: true,
  },
  {
    iconName: "data" as IconTypes,
    title: "Proven career growth",
    subtitle: "Learners report more career opportunities with a certificate.",
  },
  {
    iconName: "verified-outline" as IconTypes,
    title: "Industry-recognized",
    subtitle: "Certificates are accepted by top employers worldwide.",
  },
];

export const DEFAULT_PROMO_DATA = {
  headline: "Ignite your career!",
  subtext: "Learn new skills and make big moves for your career.",
  infoText: "",
};
